module.exports = __webpack_public_path__ + "static/media/07_crisalide.4e44b223.jpg";